import { render } from "./LocationScreen.vue?vue&type=template&id=a5d0931a&scoped=true"
import script from "./LocationScreen.vue?vue&type=script&lang=js"
export * from "./LocationScreen.vue?vue&type=script&lang=js"

import "./LocationScreen.vue?vue&type=style&index=0&id=a5d0931a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a5d0931a"]])

export default __exports__